"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8916],{

/***/ 635412:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ Dropdown; }
/* harmony export */ });
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82389);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var react_popper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(281668);




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Dropdown = (_a) => {
  var _b = _a, {
    children,
    menu,
    placement = "auto",
    showArrow = false,
    trigger = "hover"
  } = _b, rest = __objRest(_b, [
    "children",
    "menu",
    "placement",
    "showArrow",
    "trigger"
  ]);
  const [show, setShow] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
  const elementRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const tooltipRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  const arrowRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
  (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(() => {
    if (!show) {
      return;
    }
    function handleClickOutside(event) {
      if (elementRef.current && !elementRef.current.contains(event.target)) {
        setShow(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [elementRef, show]);
  const { styles, attributes } = (0,react_popper__WEBPACK_IMPORTED_MODULE_1__/* .usePopper */ .D)(elementRef.current, tooltipRef.current, {
    placement,
    modifiers: [
      {
        name: "arrow",
        options: { element: arrowRef.current }
      },
      {
        name: "offset",
        options: {
          offset: [0, 4]
        }
      }
    ]
  });
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    onMouseEnter: () => trigger === "hover" && setShow(true),
    onClick: () => {
      trigger === "click" && setShow(!show);
    },
    onMouseLeave: () => trigger === "hover" && setShow(false)
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    ref: elementRef
  }, children), /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(DropdownMenu, __spreadValues(__spreadValues({
    show,
    ref: tooltipRef,
    style: __spreadProps(__spreadValues({}, styles.popper), { zIndex: 100 })
  }, attributes.popper), rest), showArrow && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledArrow, {
    ref: arrowRef,
    style: __spreadValues({}, styles.arrow),
    "data-placement": placement,
    className: (0,_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_2__/* .getArrowClassName */ .C)(attributes) || ""
  }), menu));
};
const DropdownMenu = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].span`
  background-color: white;
  padding: 4px;
  border-radius: 4px;
  visibility: ${(props) => props.show ? "visible" : "hidden"};
  transition: visibility 0.3s;
  ${_teko_ds_foundation__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const StyledArrow = _teko_ds_foundation__WEBPACK_IMPORTED_MODULE_3__["default"].div`
  &:after {
    content: '';
    position: absolute;
    width: 6px;
    height: 6px;
    background-color: white;
    transform: rotate(45deg);
  }
  &.arrow-bottom {
    bottom: 3px;
  }
  &.arrow-top {
    top: -3px;
  }
  &.arrow-left {
    left: -3px;
  }
  &.arrow-right {
    right: 3px;
  }
`;




/***/ }),

/***/ 613295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Badge; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(621655);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(640128);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);





var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const BadgeWrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  position: relative;
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_2__/* .CommonStyles */ .F}
`;
const StyledBadge = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div(({ theme, top, right, color }) => `
  min-width: ${theme == null ? void 0 : theme.spacing.s16};
  height: ${theme == null ? void 0 : theme.spacing.s16};
  padding: ${theme == null ? void 0 : theme.spacing.s0} ${theme == null ? void 0 : theme.spacing.s4};
  background: ${color ? color : theme == null ? void 0 : theme.colors.error500};
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: ${top ? typeof top === "number" ? `${top}px` : top : 0};
  right: ${right ? typeof right === "number" ? `${right}px` : right : 0};
  transform: translate(50%,-50%);
  transform-origin: 100% 0;
`);
const StyledCaption = (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_Typography_index_es_js__WEBPACK_IMPORTED_MODULE_3__/* .Caption */ .YS)`
  text-align: center;
`;
const Badge = (_a) => {
  var _b = _a, {
    count,
    offset,
    overflowCount = 99,
    showZero = false,
    color,
    children
  } = _b, rest = __objRest(_b, [
    "count",
    "offset",
    "overflowCount",
    "showZero",
    "color",
    "children"
  ]);
  const displayCount = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(() => {
    return count < 0 ? 0 : overflowCount && count > overflowCount ? `${overflowCount}+` : count;
  }, [count, overflowCount]);
  const [top, right] = offset ? offset : [];
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BadgeWrapper, __spreadValues({}, rest), children, (count > 0 || count === 0 && showZero) && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledBadge, {
    top,
    right,
    color
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(StyledCaption, {
    level: 3,
    color: "white"
  }, displayCount)));
};




/***/ }),

/***/ 674295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ NewBellOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const NewBellOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 19 20", fill: "none" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M18.7957 11.3849L17.2124 5.68828C16.7483 4.01939 15.7396 2.55352 14.3468 1.52367C12.954 0.493823 11.2569 -0.0408992 9.52525 0.00450091C7.79363 0.049901 6.12687 0.672818 4.78992 1.77424C3.45296 2.87565 2.52253 4.39236 2.14653 6.08328L0.920696 11.5958C0.785292 12.2049 0.788423 12.8366 0.929857 13.4444C1.07129 14.0521 1.34742 14.6203 1.73785 15.1071C2.12828 15.5938 2.62305 15.9866 3.18562 16.2566C3.7482 16.5265 4.36422 16.6666 4.9882 16.6666H5.91653C6.10779 17.6085 6.6188 18.4553 7.36298 19.0636C8.10716 19.6718 9.03873 20.0041 9.99986 20.0041C10.961 20.0041 11.8926 19.6718 12.6367 19.0636C13.3809 18.4553 13.8919 17.6085 14.0832 16.6666H14.7815C15.4239 16.6667 16.0575 16.5182 16.633 16.2328C17.2085 15.9474 17.7102 15.5329 18.0989 15.0215C18.4876 14.5101 18.7528 13.9158 18.8739 13.285C18.9949 12.6541 18.9684 12.0039 18.7965 11.3849H18.7957ZM9.99986 18.3333C9.48465 18.3311 8.98267 18.1699 8.56261 17.8715C8.14256 17.5732 7.82493 17.1524 7.6532 16.6666H12.3465C12.1748 17.1524 11.8572 17.5732 11.4371 17.8715C11.0171 18.1699 10.5151 18.3311 9.99986 18.3333ZM16.7715 14.0124C16.5393 14.3205 16.2385 14.5702 15.8929 14.7416C15.5473 14.913 15.1665 15.0015 14.7807 14.9999H4.9882C4.61385 14.9999 4.2443 14.9158 3.90681 14.7538C3.56933 14.5918 3.27253 14.3561 3.03833 14.064C2.80413 13.772 2.6385 13.4311 2.55366 13.0665C2.46883 12.7019 2.46696 12.3229 2.5482 11.9574L3.7732 6.44411C4.06849 5.11595 4.79929 3.92462 5.84941 3.05949C6.89953 2.19436 8.20872 1.70509 9.56884 1.66946C10.929 1.63383 12.262 2.05388 13.356 2.86284C14.4499 3.6718 15.2421 4.82323 15.6065 6.13411L17.1899 11.8308C17.2945 12.2019 17.3111 12.5923 17.2385 12.9711C17.1659 13.3498 17.006 13.7063 16.7715 14.0124Z",
          fill: "black",
          fillOpacity: "0.88"
        }
      }
    ]
  })(props);
};




/***/ }),

/***/ 174068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ NewLayoutShoppingCartOutlined; }
/* harmony export */ });
/* harmony import */ var _helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(404334);


const NewLayoutShoppingCartOutlined = (props) => {
  return (0,_helpers_IconBase_es_js__WEBPACK_IMPORTED_MODULE_0__/* .GenIcon */ .w_)({
    tag: "svg",
    attr: { viewBox: "0 0 20 20", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_16935_405)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M18.9275 3.3975C18.6931 3.1162 18.3996 2.88996 18.068 2.73485C17.7363 2.57973 17.3745 2.49955 17.0083 2.5H3.535L3.5 2.2075C3.42837 1.59951 3.13615 1.03894 2.67874 0.632065C2.22133 0.225186 1.63052 0.000284828 1.01833 0L0.833333 0C0.61232 0 0.400358 0.0877974 0.244078 0.244078C0.0877974 0.400358 0 0.61232 0 0.833333C0 1.05435 0.0877974 1.26631 0.244078 1.42259C0.400358 1.57887 0.61232 1.66667 0.833333 1.66667H1.01833C1.22244 1.66669 1.41945 1.74163 1.57198 1.87726C1.72451 2.0129 1.82195 2.19979 1.84583 2.4025L2.9925 12.1525C3.11154 13.1665 3.59873 14.1015 4.36159 14.78C5.12445 15.4585 6.10988 15.8334 7.13083 15.8333H15.8333C16.0543 15.8333 16.2663 15.7455 16.4226 15.5893C16.5789 15.433 16.6667 15.221 16.6667 15C16.6667 14.779 16.5789 14.567 16.4226 14.4107C16.2663 14.2545 16.0543 14.1667 15.8333 14.1667H7.13083C6.61505 14.1652 6.11233 14.0043 5.69161 13.7059C5.27089 13.4075 4.95276 12.9863 4.78083 12.5H14.7142C15.6911 12.5001 16.6369 12.1569 17.3865 11.5304C18.1361 10.9039 18.6417 10.0339 18.815 9.0725L19.4692 5.44417C19.5345 5.08417 19.5198 4.71422 19.4262 4.36053C19.3326 4.00684 19.1623 3.67806 18.9275 3.3975ZM17.8333 5.14833L17.1783 8.77667C17.0743 9.35417 16.7704 9.87666 16.3199 10.2527C15.8694 10.6287 15.301 10.8342 14.7142 10.8333H4.51583L3.73167 4.16667H17.0083C17.1308 4.16594 17.2518 4.19218 17.3629 4.24355C17.4741 4.29491 17.5725 4.37012 17.6513 4.46384C17.73 4.55756 17.7872 4.66748 17.8186 4.78578C17.8501 4.90409 17.8551 5.02787 17.8333 5.14833Z",
              fill: "black",
              fillOpacity: "0.88"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M5.83353 20C6.75401 20 7.5002 19.2538 7.5002 18.3333C7.5002 17.4129 6.75401 16.6667 5.83353 16.6667C4.91306 16.6667 4.16687 17.4129 4.16687 18.3333C4.16687 19.2538 4.91306 20 5.83353 20Z",
              fill: "black",
              fillOpacity: "0.88"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M14.1667 20C15.0871 20 15.8333 19.2538 15.8333 18.3333C15.8333 17.4129 15.0871 16.6667 14.1667 16.6667C13.2462 16.6667 12.5 17.4129 12.5 18.3333C12.5 19.2538 13.2462 20 14.1667 20Z",
              fill: "black",
              fillOpacity: "0.88"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_16935_405" },
            child: [
              {
                tag: "rect",
                attr: { width: "20", height: "20", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};




/***/ }),

/***/ 279835:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "w": function() { return /* binding */ CartNumberTracking; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);


const CartNumberTracking = ({
  totalItems
}) => {
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", {
    className: "shoppingCartProductNumber",
    style: { display: "none" }
  }, totalItems);
};




/***/ }),

/***/ 788925:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ EnhancedImage; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(587021);
/* harmony import */ var _TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(675601);




var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const EnhancedImage = (props) => {
  const _a = props, { link, tracking } = _a, rest = __objRest(_a, ["link", "tracking"]);
  const img = /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_1__/* .Image */ .E, __spreadValues(__spreadValues({}, rest), !!tracking ? { tracking } : {}));
  return (link == null ? void 0 : link.href) ? /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_TekoLink_TekoLink_es_js__WEBPACK_IMPORTED_MODULE_2__/* .TekoLink */ .A, __spreadValues({}, link), img) : img;
};




/***/ }),

/***/ 29921:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* binding */ NAMESPACE; },
  "K": function() { return /* binding */ lang; },
  "t": function() { return /* binding */ t; }
});

// EXTERNAL MODULE: ../../.yarn/cache/i18next-npm-21.4.0-68c8d0fefd-cd26c166df.zip/node_modules/i18next/dist/esm/i18next.js
var i18next = __webpack_require__(396556);
;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/vi.es.js
var viLang = {
	"src.components.ProductCard.ProductCard.0": "Sản phẩm này là đồ uống có cồn, quý khách cần xác nhận mình trên 18 tuổi để mua sản phẩm!"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/lang/en.es.js
var enLang = {
	"Kết thúc sau": "End in",
	"ngày": "day",
	"Còn {{DurationDays}} ngày": "{{DurationDays}} days left",
	"Giảm trực tiếp": "Discount",
	"Tặng": "Receive",
	"GIẢM": "Decrease",
	"Không tìm thấy sản phẩm nào": "No product found",
	"Cảnh báo": "Warning",
	"src.components.ProductCard.ProductCard.0": "This is alcohol product, please confirm you are 18 years old to purchase!",
	"Tôi trên 18 tuổi": "I am over 18",
	"Tôi dưới 18 tuổi": "I am under 18",
	"Xác nhận": "Confirm",
	"TIẾT KIỆM": "Save",
	"Xem thêm": "Expand",
	"Thu gọn": "Collapse",
	"Bộ lọc đã dùng": "Used filter",
	"Xóa bộ lọc": "Clear filter",
	"Hàng trưng bày": "Sample",
	"Hàng đặt trước": "Pre-order",
	"Ngừng kinh doanh": "Stop selling",
	"Hàng quà tặng": "Gift",
	"Còn lại {{var0}}": "{{var0}} left",
	"Đã bán {{FlSaleUsedCount}}": "{{FlSaleUsedCount}} sold",
	"Hàng sắp về": "Coming soon",
	"Liên hệ": "Contact",
	"Còn {{stockQuantity}} sản phẩm": "{{stockQuantity}} left",
	"Xem tất cả": "View all",
	"Thương hiệu nổi bật": "Featured brands",
	"Danh mục sản phẩm": "Categories",
	"Sản phẩm dành cho bạn": "Products for you",
	"Chọn ngày nhận hàng": "Select delivery date",
	"Chọn khung giờ": "Select delivery time",
	"Tìm kiếm gần đây": "Recent search",
	"Chọn khu vực nhận hàng": "Select the location",
	"Vui lòng chọn khu vực nhận hàng của bạn": "Please select your location",
	"Tìm kiếm Tỉnh/ Thành phố": "Search Province/City",
	"Không tìm thấy tỉnh thành phố nào !!": "No provice/city is found !!",
	"Khi thay đổi thông tin đơn hàng thanh toán lại, đơn hiện tại sẽ bị hủy. Giá và khuyến mại đơn hàng có thể bị thay đổi. Bạn có chắc chắn muốn thực hiện thao tác này?": "When changing payment order information, current order will be canceled. Order prices and promotions are subject to change. Are you sure you want to perform this action?",
	"Trường hợp muốn thay đổi hình thức thanh toán hoặc các thông tin khác, vui lòng": "If you want to change your payment configuration or other information, please",
	"Bấm vào đây": "Click here",
	"Xem chi tiết": "View detail",
	"Cần thanh toán": "Need to pay",
	"Giao hàng bởi": "Delivered by",
	"Mã vận đơn": "Shipment code",
	"Cung cấp bởi": "Provided by",
	"Combo giảm ~": "Combo discount ~"
};



;// CONCATENATED MODULE: ../../.yarn/__virtual__/@teko-teko-ecommerce-virtual-ca6c4b0024/1/packages/teko-ecommerce/dist/i18n.es.js




var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const NAMESPACE = "teko-ecommerce";
const t = (keys, options) => {
  const text = i18next["default"].t(keys, __spreadProps(__spreadValues({}, options), { ns: NAMESPACE }));
  return text || keys;
};
const lang = {
  vi: viLang,
  en: enLang
};




/***/ }),

/***/ 60862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ NavigationIconButton; },
/* harmony export */   "W": function() { return /* binding */ NavigationButton; }
/* harmony export */ });
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(212951);

const NavigationButton = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div((param)=>{
    let { theme  } = param;
    return "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  min-width: 90px;\n  font-size: 13px;\n  position: relative;\n  cursor: pointer;\n  font-weight: 500;\n  color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.textSecondary, ";\n  a {\n    text-decoration: none;\n    color: unset;\n  }\n  &:hover {\n    color: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary500, " !important;\n    > :not(.noti) path {\n      fill: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary500, ";\n    }\n    > .noti path{\n      stroke: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary500, ";\n    }\n    .title, .text-left .title{\n      color: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary500, ";\n    }\n    .text-left {\n      text-align: left;\n    }\n  }\n  ");
});
const NavigationIconButton = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__["default"].div((param)=>{
    let { theme  } = param;
    return "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 0.5rem;\n  position: relative;\n  cursor: pointer;\n  font-weight: 500;\n  color: ".concat(theme === null || theme === void 0 ? void 0 : theme.colors.textSecondary, ";\n  a {\n    text-decoration: none;\n    color: unset;\n  }\n  &:hover {\n    color: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary500, " !important;\n    > :not(.noti) path {\n      fill: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary500, ";\n    }\n    > .noti path{\n      stroke: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary500, ";\n    }\n    .title, .text-left .title{\n      color: ").concat(theme === null || theme === void 0 ? void 0 : theme.colors.primary500, ";\n    }\n    .text-left {\n      text-align: left;\n    }\n  }\n  ");
});


/***/ }),

/***/ 193275:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BG": function() { return /* binding */ SHARED_NAV_ITEMS_TEXTS; },
/* harmony export */   "iu": function() { return /* binding */ SHARED_NAV_ITEMS; },
/* harmony export */   "m7": function() { return /* binding */ NEW_LAYOUT_NAV_ITEMS; },
/* harmony export */   "yh": function() { return /* binding */ SHARED_NAV_ITEMS_HREFS; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(749450);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883594);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(512495);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(402374);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(322312);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(234231);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71856);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(246263);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(476763);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(650896);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(192323);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(458538);


const SHARED_NAV_ITEMS_TEXTS = {
    ACCOUNT_INFORMATION: "Th\xf4ng tin t\xe0i khoản",
    ORDER_MANAGEMENT: "Quản l\xfd đơn h\xe0ng",
    WISH_LIST: "Sản phẩm y\xeau th\xedch",
    ADDRESS_BOOK: "Sổ địa chỉ",
    NOTIFICATION: "Th\xf4ng b\xe1o",
    PROMOTION_AND_UPDATE_NOTI: "Ưu đ\xe3i & Cập nhật",
    ORDERS_NOTI: "Đơn h\xe0ng",
    LOYALTY_HISTORY: "Điểm th\xe0nh vi\xean"
};
const SHARED_NAV_ITEMS_HREFS = {
    ACCOUNT_INFORMATION: "/account",
    ORDER_MANAGEMENT: "/account/orders",
    WISH_LIST: "/account/wish-list",
    ADDRESS_BOOK: "/account/addresses",
    NOTIFICATION: "/notification",
    PROMOTION_AND_UPDATE_NOTI: "/notification?type=promotion-and-update",
    ORDERS_NOTI: "/notification?type=orders",
    LOYALTY_HISTORY: "/my/loyalty-history"
};
const SHARED_NAV_ITEMS = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_1__/* .AccountOutlined */ .y, {
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.ACCOUNT_INFORMATION,
        href: SHARED_NAV_ITEMS_HREFS.ACCOUNT_INFORMATION,
        contentName: "viewAccountInfo",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_2__/* .OrderOutlined */ .y, {
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.ORDER_MANAGEMENT,
        href: SHARED_NAV_ITEMS_HREFS.ORDER_MANAGEMENT,
        contentName: "viewOrder",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_3__/* .FavouriteAlternativeOutlined */ .w, {
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.WISH_LIST,
        href: SHARED_NAV_ITEMS_HREFS.WISH_LIST,
        contentName: "viewWishList",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_4__/* .LocationOutlined */ .f, {
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.ADDRESS_BOOK,
        href: SHARED_NAV_ITEMS_HREFS.ADDRESS_BOOK,
        contentName: "viewAddressList",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_5__/* .NotificationsOutlined */ .Z, {
            size: 18,
            className: "noti"
        }),
        text: SHARED_NAV_ITEMS_TEXTS.NOTIFICATION,
        href: SHARED_NAV_ITEMS_HREFS.NOTIFICATION,
        anonymous: true,
        showByConfiguration: true,
        contentName: "viewNotification",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_6__/* .UnionPaymentOutlined */ .I, {
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.LOYALTY_HISTORY,
        href: SHARED_NAV_ITEMS_HREFS.LOYALTY_HISTORY,
        contentName: "viewLoyalty",
        regionName: "headerBar"
    }, 
];
const NEW_LAYOUT_NAV_ITEMS = [
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_7__/* .AnonymousUserProfileOutlined */ .u, {
            color: "black",
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.ACCOUNT_INFORMATION,
        href: SHARED_NAV_ITEMS_HREFS.ACCOUNT_INFORMATION,
        contentName: "viewAccountInfo",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_8__/* .CubeOutlined */ .$, {
            color: "black",
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.ORDER_MANAGEMENT,
        href: SHARED_NAV_ITEMS_HREFS.ORDER_MANAGEMENT,
        contentName: "viewOrder",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_9__/* .HeartOutlined */ .F, {
            color: "black",
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.WISH_LIST,
        href: SHARED_NAV_ITEMS_HREFS.WISH_LIST,
        contentName: "viewWishList",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_10__/* .LocationPickerColored */ .B, {
            color: "black",
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.ADDRESS_BOOK,
        href: SHARED_NAV_ITEMS_HREFS.ADDRESS_BOOK,
        contentName: "viewAddressList",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__/* .BellOutlined */ .F, {
            color: "black",
            size: 18,
            className: "noti"
        }),
        text: SHARED_NAV_ITEMS_TEXTS.NOTIFICATION,
        href: SHARED_NAV_ITEMS_HREFS.NOTIFICATION,
        anonymous: true,
        showByConfiguration: true,
        contentName: "viewNotification",
        regionName: "headerBar"
    },
    {
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .CopyrightColored */ .p, {
            size: 18
        }),
        text: SHARED_NAV_ITEMS_TEXTS.LOYALTY_HISTORY,
        href: SHARED_NAV_ITEMS_HREFS.LOYALTY_HISTORY,
        contentName: "viewLoyalty",
        regionName: "headerBar"
    }, 
];


/***/ }),

/***/ 382934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ getNavItems; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(193275);
/* harmony import */ var _i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(634655);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}



const getNavItems = (config)=>{
    const { logged , showLoyaltyItem , showNotificationItem , epicOmni948 , epicOmni1546 , displayNewLayout ,  } = config;
    let _navItems = displayNewLayout ? _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .NEW_LAYOUT_NAV_ITEMS */ .m7 : _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS */ .iu;
    if (!logged) {
        _navItems = _navItems.filter((nav)=>nav.anonymous);
    }
    if (logged && !showLoyaltyItem) {
        _navItems = _navItems.filter((nav)=>nav.contentName != "viewLoyalty");
    }
    if (logged && !epicOmni1546) {
        _navItems = _navItems.filter((nav)=>nav.contentName != "viewWishList");
    }
    if (epicOmni948) {
        // find index of notification menu in navItems
        const notiItemIndex = _navItems.findIndex((navItem)=>navItem.text === _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS_TEXTS.NOTIFICATION */ .BG.NOTIFICATION);
        // check if notification menu exists in navItems (if true, index return will >= 0)
        if (notiItemIndex >= 0) {
            // modify href of notification menu to point to promotion & update notification screen.
            // add new menus as children: promotion & update and orders.
            const newNotiItem = _objectSpreadProps(_objectSpread({}, _navItems[notiItemIndex]), {
                href: _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS_HREFS.PROMOTION_AND_UPDATE_NOTI */ .yh.PROMOTION_AND_UPDATE_NOTI,
                children: [
                    {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                width: "18px",
                                height: "18px"
                            }
                        }),
                        text: _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS_TEXTS.PROMOTION_AND_UPDATE_NOTI */ .BG.PROMOTION_AND_UPDATE_NOTI,
                        href: _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS_HREFS.PROMOTION_AND_UPDATE_NOTI */ .yh.PROMOTION_AND_UPDATE_NOTI,
                        fallbackHref: _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS_HREFS.NOTIFICATION */ .yh.NOTIFICATION,
                        anonymous: true,
                        showByConfiguration: true,
                        contentName: "viewPromotionAndUpdateNotification",
                        regionName: "headerBar"
                    },
                    {
                        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            style: {
                                width: "18px",
                                height: "18px"
                            }
                        }),
                        text: _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS_TEXTS.ORDERS_NOTI */ .BG.ORDERS_NOTI,
                        href: _constants_nav_items__WEBPACK_IMPORTED_MODULE_1__/* .SHARED_NAV_ITEMS_HREFS.ORDERS_NOTI */ .yh.ORDERS_NOTI,
                        anonymous: true,
                        showByConfiguration: true,
                        contentName: "viewOrdersNotification",
                        regionName: "headerBar"
                    }, 
                ]
            });
            _navItems[notiItemIndex] = newNotiItem;
        }
    }
    return _navItems.filter((nav)=>!nav.showByConfiguration || nav.showByConfiguration && showNotificationItem).map((item)=>{
        return !!item.children && !!item.children.length ? _objectSpreadProps(_objectSpread({}, item), {
            text: (0,_i18n__WEBPACK_IMPORTED_MODULE_2__.t)(item.text),
            children: item.children.map((childrenItem)=>_objectSpreadProps(_objectSpread({}, childrenItem), {
                    text: (0,_i18n__WEBPACK_IMPORTED_MODULE_2__.t)(childrenItem.text)
                }))
        }) : _objectSpreadProps(_objectSpread({}, item), {
            text: (0,_i18n__WEBPACK_IMPORTED_MODULE_2__.t)(item.text)
        });
    });
};


/***/ }),

/***/ 401192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ useLoyaltyMemberInfo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(859676);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(423942);
/* harmony import */ var _teko_log__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(420577);
/* harmony import */ var contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
/* harmony import */ var contexts_ServiceContext__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(643015);
/* harmony import */ var contexts_LoyaltyProvider__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(261105);







const useLoyaltyMemberInfo = (triggerFetching)=>{
    const { needToCheckLoyaltyMemberId , notFetchLoyaltyMemberInfoGlobally  } = (0,contexts_GlobalDataContext__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const { user  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_4__/* .useAuth */ .aC)();
    const { loyaltyBFFService  } = (0,contexts_ServiceContext__WEBPACK_IMPORTED_MODULE_5__/* .useServices */ .Su)();
    const { loyaltyMemberInfo: loyaltyMemberInfoCtx , loading: loadingCtx , setTriggerGetMemberInfo ,  } = (0,contexts_LoyaltyProvider__WEBPACK_IMPORTED_MODULE_6__/* .useLoyalty */ .m)();
    const hasFetchedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    const shouldFetchLoyaltyInfo = !!needToCheckLoyaltyMemberId ? (user === null || user === void 0 ? void 0 : user.telephone) && (user === null || user === void 0 ? void 0 : user.loyaltyMemberId) : user === null || user === void 0 ? void 0 : user.telephone;
    const { data: loyaltyMemberInfo , isValidating , mutate ,  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(shouldFetchLoyaltyInfo ? [
        "/member",
        user === null || user === void 0 ? void 0 : user.telephone
    ] : null, async ()=>{
        try {
            const loyaltyClientId = loyaltyBFFService.getClientId();
            if (loyaltyClientId) {
                return await loyaltyBFFService.getLoyaltyMemberInfo();
            }
        } catch (e) {
            _teko_log__WEBPACK_IMPORTED_MODULE_2__/* .logger.error */ .k.error(e, "Error fetching loyalty member info");
            return undefined;
        }
    }, {
        revalidateOnFocus: false,
        revalidateOnMount: false,
        revalidateIfStale: false,
        shouldRetryOnError: false
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        // only call API If have no data (!loyaltyMemberInfo)
        // AND not fetching data (!isValidating)
        // AND triggerFetching is true (triggerFetching is passed from the component)
        // AND hasFetchedRef is false (to prevent multiple calls)
        if (notFetchLoyaltyMemberInfoGlobally && !!(user === null || user === void 0 ? void 0 : user.telephone) && !hasFetchedRef.current && !loyaltyMemberInfo && !isValidating && !!triggerFetching) {
            hasFetchedRef.current = true;
            mutate();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        user === null || user === void 0 ? void 0 : user.telephone
    ]);
    const refetchLoyaltyMemberInfo = ()=>{
        if (notFetchLoyaltyMemberInfoGlobally) {
            mutate();
        } else {
            setTriggerGetMemberInfo((prev)=>!prev);
        }
    };
    return {
        loyaltyMemberInfo: notFetchLoyaltyMemberInfoGlobally ? loyaltyMemberInfo : loyaltyMemberInfoCtx,
        loading: notFetchLoyaltyMemberInfoGlobally ? isValidating : loadingCtx,
        refetchLoyaltyMemberInfo
    };
};


/***/ }),

/***/ 236549:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ CartOverview; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(634655);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(891987);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(929556);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(437753);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(332762);
/* harmony import */ var _teko_ecommerce__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(279835);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(534090);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(684443);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(613295);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(174068);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(276362);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(428247);
/* harmony import */ var components_desktop_organisms_style__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(60862);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35304);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: auto;\n  position: relative;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 5px;\n  left: calc(50% + 15px);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 2px;\n  left: calc(50% + 10px);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}












const MiniCart = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(68557), __webpack_require__.e(10084)]).then(__webpack_require__.bind(__webpack_require__, 468557)).then((mod)=>mod.MiniCart), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(468557)
            ]
    }
});
const StyledDropdown = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"])(_teko_ui__WEBPACK_IMPORTED_MODULE_5__/* .Dropdown */ .L)(_templateObject());
const WrapperBadge = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(_templateObject1());
const NewLayoutWrapperBadge = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_4__["default"].div(_templateObject2());
const CartOverview = (param)=>{
    let { vertical =false , showShippingFeeMiniCart =true  } = param;
    const { flattenItems , totalCartItems  } = (0,contexts__WEBPACK_IMPORTED_MODULE_6__/* .useCartV2 */ .T6)();
    const { 0: miniCartOpen , 1: setMiniCartOpen  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { displayNewLayout  } = (0,contexts__WEBPACK_IMPORTED_MODULE_7__/* .useTenantConfig */ .Wx)();
    const toggleMiniCart = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        setMiniCartOpen(!miniCartOpen);
    }, [
        miniCartOpen
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (true) {
            if (miniCartOpen) {
                document.body.style.overflow = "hidden";
                document.body.style.paddingRight = "".concat(getScrollbarWidth(), "px");
            } else {
                document.body.style.overflow = "unset";
                document.body.style.paddingRight = "unset";
            }
        }
    }, [
        miniCartOpen
    ]);
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    const { query  } = router;
    // hide MiniCart with BuyNow screen
    if (!!query.bnk) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledDropdown, _objectSpreadProps(_objectSpread({
        isOpen: miniCartOpen,
        toggle: toggleMiniCart,
        toggleType: "hover",
        onHide: ()=>setMiniCartOpen(false)
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_8__/* .getTrackingData */ .O5)({
        isTrackContent: true,
        regionName: "headerBar",
        contentName: "cartItem",
        target: "shoppingCart"
    })), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ui__WEBPACK_IMPORTED_MODULE_9__/* .DropdownToggle */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .CustomLink */ .x, {
                        href: "/cart",
                        children: displayNewLayout ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_desktop_organisms_style__WEBPACK_IMPORTED_MODULE_11__/* .NavigationIconButton */ .C, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_12__/* .NewLayoutShoppingCartOutlined */ .v, {
                                    size: 20,
                                    color: "black"
                                }),
                                totalCartItems > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NewLayoutWrapperBadge, {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Badge */ .C, {
                                        count: totalCartItems
                                    })
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: vertical ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_desktop_organisms_style__WEBPACK_IMPORTED_MODULE_11__/* .NavigationButton */ .W, {
                                className: "button",
                                style: {
                                    flexDirection: "column"
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_14__/* .ShoppingCartOutlined */ .O, {
                                        size: 36,
                                        color: "textSecondary"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__/* .Body */ .uT, {
                                        level: 2,
                                        weight: "medium",
                                        color: "textSecondary",
                                        className: "title",
                                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_16__.t)("Giỏ h\xe0ng")
                                    }),
                                    totalCartItems > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrapperBadge, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_13__/* .Badge */ .C, {
                                            count: totalCartItems
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_desktop_organisms_style__WEBPACK_IMPORTED_MODULE_11__/* .NavigationButton */ .W, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_14__/* .ShoppingCartOutlined */ .O, {
                                        size: 36,
                                        color: "textSecondary"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "ml-6 text-left",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__/* .Body */ .uT, {
                                                level: 2,
                                                weight: "medium",
                                                color: "textSecondary",
                                                className: "title",
                                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_16__.t)("Giỏ h\xe0ng của bạn")
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_15__/* .Body */ .uT, {
                                                level: 2,
                                                weight: "medium",
                                                color: "textSecondary",
                                                className: "title",
                                                children: (0,i18n__WEBPACK_IMPORTED_MODULE_16__.t)("({{cartTotalCartItems}}) sản phẩm", {
                                                    cartTotalCartItems: flattenItems.length
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ecommerce__WEBPACK_IMPORTED_MODULE_17__/* .CartNumberTracking */ .w, {
                        totalItems: totalCartItems
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_18__/* .DropdownMenu */ .h, {
                popperConfig: {
                    placement: "top-end"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MiniCart, {
                    onHide: ()=>setMiniCartOpen(false),
                    showShippingFee: showShippingFeeMiniCart
                })
            })
        ]
    }));
};
const getScrollbarWidth = ()=>{
    let width = 0;
    if ( true && document.body.scrollHeight > window.innerHeight) {
        var ref;
        if (window.scrollbarWidth) {
            return window.scrollbarWidth;
        }
        const outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.overflow = "scroll";
        document.body.appendChild(outer);
        const inner = document.createElement("div");
        outer.appendChild(inner);
        width = outer.offsetWidth - inner.offsetWidth;
        (ref = outer.parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(outer);
        window.scrollbarWidth = width;
    }
    return width;
};


/***/ }),

/***/ 268905:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ NotificationOverview; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(212951);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(618428);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(613295);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(621655);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(674295);
/* harmony import */ var _teko_ds_icon__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(322312);
/* harmony import */ var _teko_tracking__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(428247);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(929556);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(437753);
/* harmony import */ var _teko_ui__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(332762);
/* harmony import */ var components_desktop_organisms_style__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(60862);
/* harmony import */ var hooks__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(684443);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(634655);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85470);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _NotificationProvider__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(397338);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    const data = _taggedTemplateLiteral([
        "\n  width: auto;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 10px;\n  left: calc(50% + 12px);\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = _taggedTemplateLiteral([
        "\n  position: absolute;\n  top: 2px;\n  left: calc(50% + 10px);\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}











const MiniNotification = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(()=>__webpack_require__.e(/* import() */ 20764).then(__webpack_require__.bind(__webpack_require__, 720764)).then((mod)=>mod.MiniNotification), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(720764)
            ]
    }
});
const StyledDropdown = (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"])(_teko_ui__WEBPACK_IMPORTED_MODULE_4__/* .Dropdown */ .L)(_templateObject());
const WrapperBadge = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div(_templateObject1());
const NewLayoutWrapperBadge = _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_3__["default"].div(_templateObject2());
const NotificationOverview = (param)=>{
    let { title =false  } = param;
    const { 0: openDropdown , 1: setOpenDropdown  } = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const { unRead  } = (0,_NotificationProvider__WEBPACK_IMPORTED_MODULE_5__/* .useNotification */ .lm)();
    const { displayNewLayout  } = (0,hooks__WEBPACK_IMPORTED_MODULE_6__/* .useTenantConfig */ .Wx)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(StyledDropdown, _objectSpreadProps(_objectSpread({
        isOpen: openDropdown,
        toggle: ()=>{
            setOpenDropdown((prev)=>!prev);
        },
        toggleType: "hover",
        onHide: ()=>setOpenDropdown(false)
    }, (0,_teko_tracking__WEBPACK_IMPORTED_MODULE_7__/* .getTrackingData */ .O5)({
        isTrackContent: true,
        regionName: "headerBar",
        contentName: "notificationItem",
        target: "notification"
    })), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_8__/* .DropdownToggle */ .Z, {
                children: displayNewLayout ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .CustomLink */ .x, {
                    href: "/notification",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_desktop_organisms_style__WEBPACK_IMPORTED_MODULE_10__/* .NavigationIconButton */ .C, {
                        className: "button",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_11__/* .NewBellOutlined */ .t, {
                                size: 20
                            }),
                            !!unRead && unRead > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(NewLayoutWrapperBadge, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Badge */ .C, {
                                    count: unRead
                                })
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_desktop_organisms_style__WEBPACK_IMPORTED_MODULE_10__/* .NavigationButton */ .W, {
                    className: "button",
                    style: {
                        flexDirection: "column",
                        minWidth: "68px"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_icon__WEBPACK_IMPORTED_MODULE_13__/* .NotificationsOutlined */ .Z, {
                            className: "noti",
                            size: 36,
                            color: "textSecondary"
                        }),
                        !!unRead && unRead > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(WrapperBadge, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_12__/* .Badge */ .C, {
                                count: unRead
                            })
                        }),
                        title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_14__/* .Body */ .uT, {
                            level: 2,
                            weight: "medium",
                            color: "textSecondary",
                            className: "title",
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_15__.t)("Th\xf4ng b\xe1o")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ui__WEBPACK_IMPORTED_MODULE_16__/* .DropdownMenu */ .h, {
                popperConfig: {
                    placement: "bottom-end"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MiniNotification, {
                    onHide: ()=>setOpenDropdown(false)
                })
            })
        ]
    }));
};


/***/ })

}]);